const KEY = "e2law_admin_token";

export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => localStorage.setItem(KEY, t);
export const clearToken = () => localStorage.removeItem(KEY);

export const authFetch = (url, options = {}) =>
  fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
      Authorization: `Bearer ${getToken()}`,
    },
  }).then((r) => {
    if (r.status === 401) {
      clearToken();
      window.location.href = "/admin/login";
      throw new Error("unauthorized");
    }
    return r;
  });
